<template>
  <b-list-group-item :variant="is_squared ? 'success' : ''">
    <b-row>
      <b-col class="font-weight-bold" sm="2" md="2" xl="2">
        #{{ lot }}<br />{{ product_name }}
      </b-col>
      <b-col class="font-weight-bold" sm="2" md="2" xl="2">
        {{ net_kilograms_sum_in }} Kg VOLTEADOS
      </b-col>
      <b-col class="font-weight-bold" sm="2" md="2" xl="2">
        {{ net_kilograms_sum_out }} Kg PROCESADOS
      </b-col>
      <b-col class="font-weight-bold" sm="2" md="2" xl="2">
        {{ (net_kilograms_sum_in - net_kilograms_sum_out).toFixed(2) }} Kg
        RESTANTES
      </b-col>
      <b-col sm="4" md="4" xl="4">
        <create-content-buttons
          v-if="!is_squared"
          :lot="lot"
          :lot_id="lot_id"
          :fruit_id="fruit_id"
          :product_id="product_id"
          :product_name="product_name"
          :product_code="product_code"
          :net_kilograms_sum_in="net_kilograms_sum_in"
          :net_kilograms_sum_out="net_kilograms_sum_out"
        ></create-content-buttons>
        <span v-if="is_squared" class="font-weight-bold">LOTE CUADRADO</span>
      </b-col>
    </b-row>
    <span> </span>
  </b-list-group-item>
</template>

<script>
import CreateContentButtons from "./CreateContentButtons";

import numeral from "numeral";

export default {
  name: "Lot",
  components: {
    CreateContentButtons
  },
  props: {
    lot: {
      type: String,
      default: ""
    },
    net_kilograms_sum_in: {
      type: String,
      default: 0
    },
    net_kilograms_sum_out: {
      type: String,
      default: 0
    },
    lot_id: {
      type: Number,
      default: 0
    },
    fruit_id: {
      type: Number,
      default: 0
    },
    product_id: {
      type: Number,
      default: 0
    },
    product_name: {
      type: String,
      default: 0
    },
    product_code: {
      type: String,
      default: 0
    }
  },
  data() {
    return {};
  },
  computed: {
    is_squared() {
      return this.net_kilograms_sum_in - this.net_kilograms_sum_out === 0;
    }
  },
  methods: {
    difference(a, b) {
      return numeral(a).difference(b);
    }
  }
};
</script>

<style scoped></style>
